import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';

const FacilityProviderForm = ({ formik, selectedState, handleSelectState, states }) => {
  return (
    <form>
      <div className="flex flex-col gap-2">
        <h3 className="text-xl">Facility information</h3>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-full">
            <label className="label" htmlFor="name">
              Name
            </label>
            <Input
              type="text"
              placeholder="Name"
              name="facility_name"
              value={formik.values.facility_name}
              onChange={formik.handleChange}
              id="name"
            />
            {formik.errors.facility_name && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.facility_name}
              </span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="npi">
              Facility NPI
            </label>
            <Input
              type="text"
              placeholder="Facility NPI"
              name="facility_npi"
              value={formik.values.facility_npi}
              onChange={formik.handleChange}
              id="npi"
            />
            {formik.errors.facility_npi && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.facility_npi}
              </span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="id">
              Facility Atypical ID
            </label>
            <Input
              type="text"
              placeholder="Facility Atypical ID"
              name="facility_id"
              value={formik.values.facility_id}
              onChange={formik.handleChange}
              id="id"
            />
            {formik.errors.facility_id && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.facility_id}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-3 pt-7">
        <h3 className="text-xl">Facility Address information</h3>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label" htmlFor="addressFirst">
              Address
            </label>
            <Input
              type="text"
              placeholder="Address"
              name="facility_addr_1"
              value={formik.values.facility_addr_1}
              onChange={formik.handleChange}
              id="addressFirst"
            />
            {formik.errors.facility_addr_1 && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.facility_addr_1}
              </span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="addressSecond">
              Address 2
            </label>
            <Input
              type="text"
              placeholder="Address 2"
              name="facility_addr_2"
              value={formik.values.facility_addr_2}
              onChange={formik.handleChange}
              id="addressSecond"
            />
            {formik.errors.facility_addr_2 && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.facility_addr_2}
              </span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="city">
              City
            </label>
            <Input
              type="text"
              placeholder="City"
              name="facility_city"
              value={formik.values.facility_city}
              onChange={formik.handleChange}
              id="facility_city"
            />
            {formik.errors.facility_city && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.facility_city}
              </span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="state">
              State
            </label>
            <Select
              menuPortalTarget={document.body}
              placeholder="Type and select state"
              value={selectedState}
              onChange={(value) => handleSelectState(value)}
              options={states}
              inputId="state"
            />
            {formik.errors.facility_state && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.facility_state}
              </span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="zipCode">
              Zip code
            </label>
            <Input
              type="text"
              placeholder="Zip"
              name="facility_zip"
              value={formik.values.facility_zip}
              onChange={formik.handleChange}
              id="zipCode"
            />
            {formik.errors.facility_zip && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.facility_zip}
              </span>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default withErrorBoundary(FacilityProviderForm);
